// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__3UXke","summary":"CartItem_summary__3GE1C","price":"CartItem_price__21cCt","amount":"CartItem_amount__1thAg","actions":"CartItem_actions__1U6e3"};